export const useConvertTokenToStyleFormatting = (
  tokenFormatting: ParagraphTokenFormatting | undefined,
  alignment: string,
  lineHeight: number
) => {
  if (!tokenFormatting) return '';

  const size = tokenFormatting?.size ?? 12;
  const shouldStrike = tokenFormatting?.strikeThrough;
  const highlight = useTokenHighlightColor(tokenFormatting?.highlightColor);

  let decorations = [];

  if (tokenFormatting?.underline) {
    decorations.push("underline");
  }

  if (shouldStrike) {
    decorations.push("line-through");
  }

  const color = useRGBToHex(tokenFormatting?.color ?? []);
  const fontWeight = tokenFormatting?.bold ? 'bold' : 'normal';
  const fontStyle = tokenFormatting?.italic ? 'italic' : 'normal';
  const textDecoration = decorations.length > 0 ? decorations.join(' ') : 'none';
  const backgroundColor = highlight ? `background-color: ${highlight};` : '';
  const textAlign = `text-align: ${alignment};`;
  const lineHeightValue =
    decorations.includes("underline") || highlight !== undefined
      ? 1.0
      : lineHeight;

  // Return the final style string
  return `
    font-size: ${size}pt;
    color: ${color};
    font-weight: ${fontWeight};
    font-style: ${fontStyle};
    text-decoration: ${textDecoration};
    ${backgroundColor}
    ${textAlign}
    line-height: ${lineHeightValue};
  `.trim(); // Remove any unnecessary spaces or newlines
};
